import createReducer, { ActionCreatorHelper } from 'store/createReducer';

export interface Statistic {
    impressions: number;
    clicks: number;
    responses: number;
    spent: number; // в копейках
    daysCount: number;
}

// ----------------------- actions -------------------------------------

const SET_STATISTIC = 'SET_STATISTIC';
const SET_LOADING = 'SET_LOADING';
const SET_ERROR = 'SET_ERROR';
const RESET_CAMPAIGN_STATISTIC = 'RESET_CAMPAIGN_STATISTIC';

interface PayloadTypes {
    [SET_STATISTIC]: Statistic;
    [SET_LOADING]: boolean;
    [SET_ERROR]: boolean;
    [RESET_CAMPAIGN_STATISTIC]: null;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setStatistic = ActionCreator(SET_STATISTIC);
export const setLoading = ActionCreator(SET_LOADING);
export const setError = ActionCreator(SET_ERROR);
export const resetCampaignStatistic = ActionCreator(RESET_CAMPAIGN_STATISTIC);

// ----------------------- /actions -------------------------------------

// ----------------------- reducer ------------------------------------
interface StatisticState {
    statistic: Statistic;
    loading: boolean;
    isError: boolean;
}

const EMPTY_STATISTIC = {
    impressions: 0,
    clicks: 0,
    responses: 0,
    spent: 0,
    daysCount: 0,
};

const STATISTIC_STATE: StatisticState = {
    statistic: {
        ...EMPTY_STATISTIC,
    },
    loading: false,
    isError: false,
};

export default createReducer<StatisticState, PayloadTypes>(STATISTIC_STATE, {
    [SET_STATISTIC]: (state, { payload }) => ({
        ...state,
        statistic: payload,
    }),
    [SET_LOADING]: (state, { payload }) => ({
        ...state,
        loading: payload,
    }),
    [SET_ERROR]: (state, { payload }) => ({
        ...state,
        isError: payload,
    }),
    [RESET_CAMPAIGN_STATISTIC]: (state) => ({
        ...state,
        statistic: {
            ...EMPTY_STATISTIC,
        },
        loading: false,
        isError: false,
    }),
});
